import { useMemo, useState } from 'react'
import { View, Text, TextInput, TouchableOpacity, FlatList, Modal, StyleSheet } from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import { useTranslation } from 'react-i18next'
import { colors, fonts, radius } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import Ionicons from '@expo/vector-icons/Ionicons'
export default function ModaleUtenti({ members, selected, onToggle, onClose, maxSelect }) {
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const insets = useSafeAreaInsets()

  const filtered = members.filter(m =>
    !search || m.display_name?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <Modal visible animationType="slide" onRequestClose={onClose}>
      <SafeAreaView style={[styles.container, { backgroundColor: tc.bg }]} edges={['bottom']}>
        {/* Header */}
        <View style={[styles.header, { paddingTop: insets.top + 14 }]}>
          <View style={styles.headerRow}>
            <Text style={styles.title}>{t('pick.compare_users')}</Text>
            <Text style={styles.counter}>{selected.length}/{maxSelect}</Text>
            <TouchableOpacity style={styles.confirmBtn} onPress={onClose}>
              <Text style={styles.confirmBtnText}>{t('pick.confirm')}</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.closeBtn} onPress={onClose}>
              <Text style={styles.closeBtnText}>✕</Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Search */}
        <View style={styles.searchRow}>
          <Ionicons name="close" size={16} color={tc.textMuted} />
          <TextInput
            style={styles.searchInput}
            value={search}
            onChangeText={setSearch}
            placeholder={t('pick.search_user')}
            placeholderTextColor={tc.textDim}
            autoCorrect={false}
            autoCapitalize="none"
          />
          {search ? <TouchableOpacity onPress={() => setSearch('')}><Text style={{ color: tc.textMuted, fontSize: 16 }}>✕</Text></TouchableOpacity> : null}
        </View>

        {/* Lista */}
        <FlatList
          data={filtered}
          keyExtractor={item => String(item.id_user)}
          keyboardShouldPersistTaps="handled"
          renderItem={({ item: m }) => {
            const isSel = selected.includes(m.id_user)
            const disabled = !isSel && selected.length >= maxSelect
            return (
              <TouchableOpacity
                style={[styles.memberRow, isSel && styles.memberRowSelected, disabled && { opacity: 0.35 }]}
                onPress={() => !disabled && onToggle(m.id_user)}
                activeOpacity={disabled ? 1 : 0.7}
              >
                <Text style={styles.memberName}>{m.display_name}</Text>
                {isSel && <Text style={styles.checkmark}>✓</Text>}
              </TouchableOpacity>
            )
          }}
        />
      </SafeAreaView>
    </Modal>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  container:      { flex: 1, backgroundColor: tc.bg },
  header:         { paddingHorizontal: 14, paddingBottom: 14, borderBottomWidth: 1, borderBottomColor: tc.border },
  headerRow:      { flexDirection: 'row', alignItems: 'center', gap: 8 },
  title:          { fontFamily: fonts.condensedBold, fontSize: 18, color: tc.text, flex: 1 },
  counter:        { fontFamily: fonts.condensedBold, fontSize: 14, color: tc.rosaText },
  confirmBtn:     { backgroundColor: tc.rosa, borderRadius: radius.md, paddingHorizontal: 14, paddingVertical: 8 },
  confirmBtnText: { color: tc.brandText, fontFamily: fonts.condensedBold, fontSize: 13 },
  closeBtn:       { backgroundColor: tc.bgCard2, borderWidth: 1, borderColor: tc.border, borderRadius: radius.md, width: 32, height: 32, alignItems: 'center', justifyContent: 'center' },
  closeBtnText:   { color: tc.textMuted, fontSize: 14 },
  searchRow:      { flexDirection: 'row', alignItems: 'center', gap: 10, padding: 10, paddingHorizontal: 16, borderBottomWidth: 1, borderBottomColor: tc.border },
  searchInput:    { flex: 1, fontSize: 15, color: tc.text },
  memberRow:      { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', padding: 13, paddingHorizontal: 16, borderBottomWidth: 1, borderBottomColor: tc.border },
  memberRowSelected: { backgroundColor: tc.rosaSubtle },
  memberName:     { fontSize: 14, color: tc.text },
  checkmark:      { color: tc.rosaText, fontSize: 13, fontFamily: fonts.condensed },
})